<template>
  <div>
    <tr>
      <td>
        <div class="col-md" id="type">
          <div class="row">
            <div class="col-lg">
              <base-button
                type="success"
                round
                @click.native="modals.addHolidays = true"
                :disabled="disableButton"
              >
                <i class="tim-icons icon-simple-add"></i>Add New
              </base-button>
              <modal
                :show.sync="modals.addHolidays"
                footer-classes="justify-content-center"
                type="notice"
              >
                <h3 slot="header" class="modal-title">Add Holidays Details</h3>
                <div class="modal-body">
                  <div class="row">
                    <div class="col-md-12">
                      <form @submit.prevent>
                        <div class="row justify-content-center mt-12">
                          <div class="col-sm-12">
                            <div>
                              <base-input
                                v-model="holidayName"
                                type="text"
                                label="Holiday Name "
                                placeholder="Holiday Name..."
                              ></base-input>
                              <base-input
                                v-model="holidayStartDate"
                                type="text"
                                label="Start and End Date"
                              >
                                <el-date-picker
                                  v-model="holidayStartDate"
                                  type="daterange"
                                  placeholder="Start Date..."
                                  start-placeholder="Start date"
                                  end-placeholder="End date"
                                >
                                </el-date-picker>
                              </base-input>
                            </div>
                          </div>
                          <div>
                            <base-button
                              class="mt-3"
                              native-type="submit"
                              type="success"
                              @click="
                                sendHolidays(holidayName, holidayStartDate)
                              "
                              >Submit</base-button
                            >
                            <base-button
                              class="mt-3"
                              type="danger"
                              @click.native="modals.addHolidays = false"
                              >Cancel</base-button
                            >
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </modal>
            </div>
          </div>
          <div class="row">
            <!-- style="color: #00f2c3" -->
            <div class="col-lg">
              <p>Manage holidays by adding new or deleting records</p>
            </div>
          </div>
        </div>
      </td>
    </tr>

    <!-- div table -->
    <div class="col-lg-12 col-md" style="padding-top: 10px">
      <h3 class="card-title brightness">
        <div>
          <div
            class="
              col-12
              d-flex
              justify-content-center justify-content-sm-between
              flex-wrap
            "
          >
            <el-select
              class="select-primary mb-3 pagination-select"
              v-model="pagination.perPage"
              placeholder="Per page"
            >
              <el-option
                class="select-primary"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <base-input type="success">
              <el-input
                type="search"
                class="mb-3 search-input"
                clearable
                prefix-icon="el-icon-search"
                placeholder="Search records"
                v-model="searchQuery"
                aria-controls="datatables"
              ></el-input>
            </base-input>
          </div>
          <el-table
            :data="
              queriedData.filter(
                (data) =>
                  !searchQuery ||
                  data.holidayName
                    .toLowerCase()
                    .includes(searchQuery.toLowerCase())
              )
            "
            :header-cell-style="{
              background: 'transparent',
              border: 'transparent',
              'padding-bottom': '0%',
              'padding-center': '10px',
              color: 'white',
            }"
            :cell-style="{
              border: 'transparent',
              'padding-center': '20px',
            }"
          >
            <el-table-column
              v-for="column in tableHolidays"
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="column.label"
            >
            </el-table-column>
            <el-table-column align="right" label="Delete">
              <div slot-scope="props">
                <el-tooltip content="Delete" placement="bottom" effect="light">
                  <base-button
                    class="edit btn-link"
                    type="danger"
                    size="sm"
                    icon
                    @click="deleteHolidays(props.$index, props.row)"
                    :disabled="disableButton"
                  >
                    <i class="tim-icons icon-simple-remove"></i>
                  </base-button>
                </el-tooltip>
              </div>
            </el-table-column>
          </el-table>
        </div>
        <div
          slot="footer"
          class="
            col-12
            d-flex
            justify-content-center justify-content-sm-between
            flex-wrap
          "
        >
          <div>
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <base-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          ></base-pagination>
        </div>
      </h3>
    </div>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  TimeSelect,
  DatePicker,
  Select,
  Option,
} from "element-ui";
import moment from "moment";
import { TabPane, Tabs } from "src/components";
import { Modal, BasePagination } from "src/components";
import LineChart from "@/components/Charts/LineChart";
import swal from "sweetalert2";
export default {
  components: {
    TabPane,
    Tabs,
    Modal,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    [Option.name]: Option,
    [Select.name]: Select,
    LineChart,
    BasePagination,
  },
  data() {
    return {
      searchQuery: "",
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchedData: [],
      holidayName: "",
      holidayStartDate: "",
      holidaysList: [],
      holidaysTable: [],
      // Running holiday
      runningHolidays: [],
      startDate: "",
      endDate: "",
      cluster: "",
      multi: "",
      holiday: "",
      date: "",
      setHoliday: [],
      holidayTable: [],
      setHolidayhistoryData: [],
      holidayDisplayTable: [],
      modals: {
        addHolidays: false,
        add: false,
        holidays: false,
        edit: false,
        editweekend: false,
        editholiday: false,
      },
      disableButton: true,
      loading: false,
      tableHolidays: [
        {
          prop: "holidayName",
          label: "Holiday",
        },
        {
          prop: "startDate",
          label: "Start Date",
        },
        {
          prop: "endDate",
          label: "End Date",
        },
      ],

      selects: {
        holidayInMalaysia: [
          { value: "010120010120", label: "New Year's Day" },
          { value: "080220080220", label: "Thaipusam" },
          { value: "260120270120", label: "Chinese New Year" },
          { value: "010520010520", label: "Labour Day" },
          { value: "070520070520", label: "Wesak Day" },
          { value: "100520100520", label: "Nuzul Al-Quran" },
          { value: "240520260520", label: "Hari Raya Aidilfitri" },
          { value: "310720020820", label: "Hari Raya Haji" },
          { value: "310820310820", label: "Merdeka Day" },
          { value: "200820200820", label: "Awal Muharram" },
          { value: "060620060620", label: "Agong's Birthday" },
          { value: "160920160920", label: "Malaysia Day" },
          { value: "141120151120", label: "Deepavali" },
          { value: "291020291020", label: "Prophet Muhammad's Birthday" },
          { value: "251220251220", label: "Christmas Day" },
        ],
        multi: "",
        multicast: [],
        multicastid: [],
        device: "",
        devices: [],
        scheType: "multicast",
        // schedulerType: [
        //   { value: "multicast", label: "Cluster" }
        // ],
        hour: "",
        hours: [
          { value: 1, label: "1 a.m." },
          { value: 2, label: "2 a.m." },
          { value: 3, label: "3 a.m." },
          { value: 4, label: "4 a.m." },
          { value: 5, label: "5 a.m." },
          { value: 6, label: "6 a.m." },
          { value: 7, label: "7 a.m." },
          { value: 8, label: "8 a.m." },
          { value: 9, label: "9 a.m." },
          { value: 10, label: "10 a.m." },
          { value: 11, label: "11 a.m." },
          { value: 12, label: "12 p.m." },
          { value: 13, label: "1 p.m." },
          { value: 14, label: "2 p.m." },
          { value: 15, label: "3 p.m." },
          { value: 16, label: "4 p.m." },
          { value: 17, label: "5 p.m." },
          { value: 18, label: "6 p.m." },
          { value: 19, label: "7 p.m." },
          { value: 20, label: "8 p.m." },
          { value: 21, label: "9 p.m." },
          { value: 22, label: "10 p.m." },
          { value: 23, label: "11 p.m." },
          { value: 0, label: "12 a.m." },
        ],
        min: "",
        mins: [
          { value: "0", label: "00" },
          { value: 5, label: "05" },
          { value: 10, label: "10" },
          { value: 15, label: "15" },
          { value: 20, label: "20" },
          { value: 25, label: "25" },
          { value: 30, label: "30" },
          { value: 35, label: "35" },
          { value: 40, label: "40" },
          { value: 45, label: "45" },
          { value: 50, label: "50" },
          { value: 55, label: "55" },
        ],
        status: [
          { value: "On", label: "On" },
          { value: "Off", label: "Off" },
        ],
        br: [
          { value: 10, label: "10" },
          { value: 20, label: "20" },
          { value: 30, label: "30" },
          { value: 40, label: "40" },
          { value: 50, label: "50" },
          { value: 60, label: "60" },
          { value: 70, label: "70" },
          { value: 80, label: "80" },
          { value: 90, label: "90" },
          { value: 100, label: "100" },
        ],
      },
    };
  },
  created() {},
  mounted() {
    let roleSession = JSON.parse(sessionStorage.getItem("accessList"));

    
    for (var i = 0; i < roleSession.length; i++) {
      
      if (roleSession[i] === "cluster.update") {
       
        this.disableButton = true;
        // this.disabledButton = true;
      }
      if (roleSession[i] === "admin.view") {
        this.disableButton = false;
      }
      if (roleSession[i] === "cluster.update") {
        this.disableButton = false;
      }
    }
    this.getHolidays();
   
  },
  methods: {
    deleteHolidays(index, row) {
     
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteRow(row);
          swal({
            title: "Deleted!",
            text: `You deleted ${row.holidayName}`,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false,
          });
        }
      });
    },
    sendHolidays(holidayName, holidayStartDate) {
     

      let startDate = moment(holidayStartDate[0]).unix();
      let endDate = moment(holidayStartDate[1]).unix();


      let payload = {
        holiday_list: [
          {
            holidayname: holidayName,
            startdate: startDate.toString(),
            enddate: endDate.toString(),
          },
        ],
      };

      let payloadTable = {
        holidayName: holidayName,
        startDate: moment(holidayStartDate[0]).format("YYYY-MM-DD"),
        endDate: moment(holidayStartDate[1]).format("YYYY-MM-DD"),
      };
  

      // send payload
      this.$http
        .post(":8004/api/v1/holidays", payload)
        .then((res) => {
          if (res.error) {
            swal({
              type: "error",
              title: "Oops... Something went wrong!",
              text: res.message,
            });
            //pupout oeror
          
          } else {
            swal({
              type: "success",
              title: "New Holiday Added! You’ve added " + holidayName,
              // text: res.message
            }).then((result) => {
              if (result.value) {
                this.$router.go();
              }
            });

            this.holidaysTable.push(payloadTable);
          
            this.getHolidays();
          }
        })
        .catch((err) => {
       
        });
      this.modals.addHolidays = false;
      this.holidayName = "";
      this.holidayStartDate = "";
    },
    getHolidayData(clusterID) {
      // get table data for holidays
     
      const arr = [];
      this.$http
        .get(":8002/api/v1/manage/cluster/attribute/" + clusterID + "/holidays")
        .then((res) => {
          if (res.error) {
          
          } else {
          
            let data = JSON.parse(JSON.stringify(res.message.attribute_list));
          
            let arr = JSON.parse(res.message.attribute_list[0].value);
            this.getHoliday = JSON.parse(res.message.attribute_list[0].value);
           
            for (var i = 0; i < arr.length; i++) {
             

              // convert on / off to human readable format
              if (parseInt(arr[i].slice(10, 12), 16) === 0) {
                var onoff = "off";
              } else {
                var onoff = "on";
              }
              parseInt(arr[i].slice(10, 12), 16);
              // slice array to 7 portion and assign to variable
              var my_holiday = {
                header: parseInt(arr[i].slice(0, 2), 16),
                profile: parseInt(arr[i].slice(2, 4), 16),
                index: parseInt(arr[i].slice(4, 6), 16),
                hour: parseInt(arr[i].slice(6, 8), 16),
                min: parseInt(arr[i].slice(8, 10), 16),
                onoff: onoff,
                brightness: parseInt(arr[i].slice(12, 14), 16) * 10,
              };

              this.holidays.push(my_holiday);
              this.charts3.push(my_holiday);
          
              this.schedulerBrightnessChart3(this.charts3);
            }
          }
        })
        .catch((err) => {
      
        });
      // clear array
      this.holidays = [];
      this.charts3 = [];
    },

    getlist() {
      // get list of clusters
      const arr = [];
      this.$http
        .get(":8002/api/v1/manage/cluster")
        .then((res) => {
          if (res.error) {
           
          } else {
            let data = res.message.cluster_list;
           
            this.multicast = data;
         
            // if array empty, promp error and redirect to create cluster page
            if (this.multicast.length < 1) {
              swal({
                title: "Cluster empty",
                text: "Please create cluster to continue!",
                type: "warning",
                confirmButtonText: "OK",
                confirmButtonClass: "btn btn-success btn-fill",
                buttonsStyling: false,
              }).then(() => {
                this.$router.push("/admin/clustermanagement");
              });
            }

          
            this.selects.multicast = [];
            for (let i = 0; i < this.multicast.length; i++) {
              let multicast_array = {
                value: this.multicast[i].clusterid,
                label: this.multicast[i].clustername,
              };
              let data = {
                id: this.multicast[i].clusterid,
                multiid: this.multicast[i].multicastid,
              };
              this.selects.multicastid.push(data);
             
              this.selects.multicast.push(multicast_array);
            }
            // assign default value to table
            this.selects.multi = this.multicast[0].clusterid;

            // this.getHolidayData(this.selects.multi);
          }
        })
        .catch((err) => {
         
        });
    },
    getHolidays() {
      // get table data for holidays list
      this.holidaysTable = [];
      this.holidaysList = [];
      const arr = [];
      this.$http
        .get(":8004/api/v1/holidays")
        .then((res) => {
          

          var holidaySelection = res.message.holiday_list;
    

          for (var i = 0; i < holidaySelection.length; i++) {
            let payload = {
              value: holidaySelection[i].HolidayID,
              label: holidaySelection[i].holidayname,
            };

            let payloadTable = {
              holidayName: holidaySelection[i].holidayname,
              holidayID: holidaySelection[i].HolidayID,
              startDate: holidaySelection[i].startdate,
              endDate: holidaySelection[i].enddate,
            };

          
            this.holidaysTable.push(payloadTable);
            this.holidaysList.push(payload);
          }
          
        })
        .catch((err) => {
         
        });
    },
    deleteRow(row) {
    
      this.$http
        .delete(":8004/api/v1/holidays/" + row.holidayID)
        .then((res) => {
          if (res.error) {
            swal({
              type: "error",
              title: "Oops... Something went wrong!",
              text: res.message,
            });
          } else {
          
            swal({
              type: "success",
              title: "Delete Successful!",
              text: res.message,
            }).then((result) => {
              if (result.value) {
                this.$router.go();
              }
            });
            this.getHolidays();
          }
        })
        .catch((err) => {
          
        });
    },
  },
  computed: {
    queriedData() {
      let result = this.holidaysTable;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.holidaysTable.length;
    },
  },
};
</script>
